import {
  formatToLocalDate,
  formatToLocalDateTime,
  formatToLocalTime,
} from "../../../helpers/dateConversion"

export default function TypeDate({ value, description, fieldSubType }) {
  const subType = String(fieldSubType || "date").toLowerCase()

  let formattedValue = formatToLocalDate(value)
  switch (subType) {
    case "time":
      formattedValue = formatToLocalTime(value)
      break
    case "datetime":
      formattedValue = formatToLocalDateTime(value)
      break
    case "date":
    default:
      formattedValue = formatToLocalDate(value)
      break
  }

  return (
    <div>
      <label>{description} </label>
      {formattedValue}
    </div>
  )
}
